import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const SessionListItem = ({
   action,
   borderStyle,
   endTime,
   labels,
   location,
   linkTo,
   name,
   startTime
}) => (
   <View
      display="flex"
      padding="12px 3px[a-b] 15px 0px[c-f]"
      borderTop={borderStyle}>
      <View
         display="none[a-b] block[c] none[d] block[e-f]"
         width="120px"
         flex="0 0 auto">
         <Text color="#666" size="1" weight="medium" transform="uppercase">
            {startTime}
         </Text>
      </View>
      <View flex="1 1 auto">
         <Link to={linkTo}>
            <Text size="2" weight="medium" color="#111">
               {name}
            </Text>
         </Link>
         <View display="flex" flexFlow="row wrap">
            {labels.map(label => (
               <View key={label.id} display="flex" alignItems="center" marginRight="12px">
                  <View
                     width="9px"
                     height="9px"
                     backgroundColor={label.color}
                     borderRadius="50%"
                     marginRight="12px"
                  />
                  <Text key={label.id} size="1.5" color="#444">
                     {label.name}
                  </Text>
               </View>
            ))}
            <Text color="#888" size="1">
               {`${startTime} ${endTime ? `- ${endTime}` : ''}`}
               {location ? ` - ${location}` : ''}
            </Text>
         </View>
      </View>
      {action && (
         <View flex="0 0 auto">
            {action}
         </View>
      )}
   </View>
)

SessionListItem.propTypes = {
   action: PropTypes.node,
   borderStyle: PropTypes.string,
   endTime: PropTypes.string,
   labels: PropTypes.array.isRequired,
   location: PropTypes.string,
   linkTo: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired,
   startTime: PropTypes.string.isRequired
}

SessionListItem.defaultProps = {
   action: undefined,
   borderStyle: '1px solid #ddd',
   endTime: undefined,
   location: undefined
}

export default SessionListItem
